var exports = {
  "Kk": "GuildMemberActionsSheet.module__icon___ejB2RF",
  "wx": "GuildMemberActionsSheet.module__header___ejB2RF",
  "Se": "GuildMemberActionsSheet.module__headerInfo___ejB2RF",
  "Bv": "GuildMemberActionsSheet.module__headerName___ejB2RF",
  "sD": "GuildMemberActionsSheet.module__headerTag___ejB2RF",
  "im": "GuildMemberActionsSheet.module__headerAvatarImg___ejB2RF",
};

module.exports = exports;
